import React, { ReactNode } from 'react';
import { Grid2Props } from '@mui/material/Unstable_Grid2';

interface GridChildProps {
    children: ReactNode;
    gridProps?: Grid2Props;
}

const GridChild: React.FC<GridChildProps> = ({ children, gridProps }) => {
    return (
        <>
            {React.Children.map(children, child => {
                if (React.isValidElement(child)) {
                    return React.cloneElement(child, {
                        ...child.props,
                        gridProps,
                    });
                }
                return child;
            })}
        </>
    );
};

export default GridChild;
